var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b9df0d399d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9df0d399d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a7adc3",
    d: "M 27.089844 0 L 2.921875 0 C 1.585938 0 0.511719 1.089844 0.511719 2.410156 L 0.511719 26.621094 C 0.511719 27.957031 1.601562 29.03125 2.921875 29.03125 L 27.078125 29.03125 C 28.414062 29.03125 29.488281 27.941406 29.488281 26.621094 L 29.488281 2.410156 C 29.5 1.089844 28.425781 0 27.089844 0 Z M 9.097656 23.949219 L 4.8125 23.949219 L 4.8125 11.082031 L 9.097656 11.082031 Z M 6.945312 9.527344 C 5.597656 9.527344 4.507812 8.4375 4.507812 7.085938 C 4.507812 5.738281 5.597656 4.648438 6.945312 4.648438 C 8.296875 4.648438 9.386719 5.738281 9.386719 7.085938 C 9.386719 8.4375 8.296875 9.527344 6.945312 9.527344 Z M 25.21875 23.949219 L 20.917969 23.949219 L 20.816406 16.308594 C 20.816406 16.308594 20.917969 14.277344 18.695312 14.292969 C 16.472656 14.304688 16.167969 16.308594 16.167969 16.308594 L 16.167969 23.949219 L 11.839844 23.949219 L 11.839844 11.082031 L 15.996094 11.082031 L 15.996094 12.851562 C 15.996094 12.851562 16.167969 12.273438 17.128906 11.589844 C 18.085938 10.90625 19.667969 10.761719 20.351562 10.789062 C 21.035156 10.820312 21.964844 10.703125 23.519531 11.777344 C 25.1875 12.925781 25.230469 15.933594 25.230469 15.933594 Z M 25.21875 23.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogoIcon);
export default __webpack_public_path__ + "static/media/linkedin-logo-icon.9236e115b97a73c69f93ed716f32a213.svg";
export { ForwardRef as ReactComponent };